import styled from "styled-components";

export const GamesOpenSessionPlayButtonDefaultBox = styled.div`
    cursor: pointer;
    position: absolute;
    bottom: calc(-1 * var(--open-session-record-padding) - var(--open-session-record-content-padding));
    right: calc(-1 * var(--open-session-record-padding) - var(--open-session-record-content-padding));
`